// 这是一个用于授权代币给指定地址（如路由器、合约）的工具函数

import { erc20Abi, WalletClient } from 'viem';
import { parseUnits } from 'viem';
import { readContract } from 'wagmi/actions';
import { wagmiConfig } from './wagmi';
import { to0xString } from './toHex';
/**
 * 授权代币给指定地址使用
 * 
 * @param account - 当前用户的钱包地址（谁拥有这些代币）
 * @param contractAddress - 代币合约地址（要授权的那个代币，比如 USDC、WETH）
 * @param amount - 要授权的数量（人类可读的数字，比如 100）
 * @param spenderAddress - 被授权方地址（谁可以使用这些代币，比如路由合约）
 * @param decimals - 代币的小数位数（比如 USDC 是 6，ETH 是 18）
 * @returns Promise<boolean> - 授权是否成功
 */
const approve = async (
  account: string,           // 钱包地址
  contractAddress: string,   // 代币合约地址 ← 这就是你问的"代币地址"
  amount: number,            // 数量
  spenderAddress: string,    // 被授权方（比如 Uniswap Router）
  decimals: number,          // 精度
  walletClient: WalletClient
) => {
  try {

    const hexAccount = to0xString(account);
    const hexContract = to0xString(contractAddress);  // ← 这个就是代币地址
    const hexSpender = to0xString(spenderAddress);


    const currentAllowance = await readContract(wagmiConfig, {
      address: hexContract, // 代币合约地址
      abi: erc20Abi, // 使用标准 ERC-20 ABI
      functionName: 'allowance', // 调用 allowance 方法
      args: [hexAccount, hexSpender],
      authorizationList: undefined
    });
    console.log('当前已授权额度:', currentAllowance);

    const amountToApprove = parseUnits(amount.toString(), decimals);


    if (currentAllowance >= amountToApprove) {
      console.log('授权额度已足够，无需重复授权');
      return true;
    }


    const hash = await walletClient.writeContract({
      address: hexContract,
      abi: erc20Abi,
      functionName: 'approve',
      args: [hexSpender, amountToApprove],
      account: hexAccount,
      chain: undefined
    });
    console.log('授权交易已发送，hash:', hash);

    return true;

  } catch (error) {
    console.error('Approve 失败:', error);
    throw error;
  }
};

export default approve;

